import React, { FC } from 'react';

import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Element } from 'react-scroll';

import VideoPlayer from '../../../../components/VideoPlayer/VideoPlayer';
import { useTextStyles } from '../../../../utils/styles';
import { StartCourseBtn } from '../StartCourseBtn';
import useStyles from './styles';

interface AboutCourseBlockProps {
  description?: string | null;
  verseId?: number | null;
  videoFrameRef: React.RefObject<HTMLFrameElement>;
  isCourseStarted: boolean;
  handleStartCourse: () => void;
}

const AboutCourseBlock: FC<AboutCourseBlockProps> = ({
  description,
  verseId,
  videoFrameRef,
  handleStartCourse,
  isCourseStarted,
}) => {
  const classes = useStyles();
  const textClasses = useTextStyles();

  const { t } = useTranslation();

  return (
    <Container className={classes.wrapper}>
      <div className={classes.infoWrapper}>
        <Typography variant="h2" className={cx(classes.title, textClasses.h2)}>
          {t('page.course.aboutCourse')}
        </Typography>
        <Typography className={cx(classes.description, textClasses.introText)}>
          {description}
        </Typography>
        <StartCourseBtn isCourseStarted={isCourseStarted} handleStartCourse={handleStartCourse} />
      </div>
      {verseId && (
        <Element name="introductionVideo" id="introductionVideo" className={classes.videoBlockWrap}>
          <div className={classes.videoWrap}>
            <div className={classes.videoBlock}>
              <VideoPlayer
                className={classes.video}
                verseId={`${verseId}`}
                ref={videoFrameRef}
                additionalIframeUrlParams="&hamburger=0"
              />
            </div>
          </div>
        </Element>
      )}
    </Container>
  );
};

export default AboutCourseBlock;
